var error = 'error'; // 错误
var success = 'success'; // 成功
var warning = 'warning'; // 警告

export function emptyRules(val) {
  if (val) {
    return success
  }
  return error
}

export function nameRules(val) {
  if (val) {
    if (/^[a-zA-Z][a-zA-Z ]{1,40}[a-zA-Z]$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}

export function phoneRules(val) {
  if (val) {
    val = val.replace(/\s/g, '')
    if (/^(0|52)?[1-9]{1}[0-9]{9}$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}

export function companyPhoneRules(val) {
  if (val) {
    val = val.replace(/\s/g, '')
    if (/^(0|52)?[1-9]{1}[0-9]{9}$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}

export function phoneRepeatRules(val, list) {
  if (list.filter(e => e == val).length > 1) {
    return warning
  }
  return phoneRules(val)
}

export function passwordRules(val) {
  if (val) {
    if (val.length >= 4) {
      return success
    }
    return warning
  }
  return error
}

export function comfirmPasswordRules(val, oldVal) {
  if (val) {
    if (val.length >= 4) {
      if (oldVal !== val) {
        return warning
      }
      return success
    }
    return warning
  }
  return error
}

export function pinRules(val) {
  if (val) {
    if (val.length === 4) {
      return success
    }
    return warning
  }
  return error
}

export function comfirmPinRules(val, oldVal) {
  if (val) {
    if (val.length === 4) {
      if (oldVal !== val) {
        return warning
      }
      return success
    }
    return warning
  }
  return error
}

export function validateCodeRules(val) {
  if (val) {
    if (val.length === 4) {
      return success
    }
    return warning
  }
  return error
}

export function bankCardRules(val,code) {
  if (val) {
    if('ACCOUNT' === code){
      if (/^[0-9]{18}$/.test(val)) {
        return success
      }
    } else if ('CARD' === code){
      if (/^[0-9]{16}$/.test(val)) {
        return success
      }
    } else if (/^[0-9]{16,18}$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}

export function idcardRules(val) {
  val = val.replace(/[^a-zA-Z0-9]/g, '')
  if (val) {
    if (/^[a-zA-Z0-9]{18}$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}

export function emailRules(val) {
  if (val) {
    if (/^.+@.+$/.test(val)) {
      return success
    }
    return warning
  }
  return error
}
